{
  "income": [
    {
      "salaryDeductions": [],
      "limitedCompanyDirector": {
        "grossSalary": 77000
      },
      "firstApplicant": true,
      "incomeBenefits": [],
      "salarySuppliments": [],
      "additionalIncomes": [
        {
          "payFrequency": "annually",
          "payPerPeriod": 100,
          "isProven": true,
          "id": "ddbf112a5f5237bfdfb26801e4992645",
          "type": "Other"
        }
      ],
      "id": "fefb2688cb952c772ef3d4dfa98fd96d",
      "employmentStatus": "DirectorLimitedCompany"
    }
  ],
  "preferences": {
    "marketingPreferences": "email;phone;sms",
    "feePaymentPreference": "add_to_loan",
    "initialPeriodPreference": "two_years",
    "repaymentMethodPreference": "capital_repayment",
    "mortgageTypePreference": "fixed_rate"
  },
  "appointments": [
    {
      "calendlyEventName": "Mojo Mortgage Appointment",
      "utmSource": "Online",
      "acuityAppointmentId": 1490553758,
      "calendlyEventDuration": 30,
      "utmMedium": "Results Page",
      "assignee": "Alan Smithee",
      "category": "CoreInitial",
      "appointmentDate": "2025-06-19T15:30:00.000Z",
      "createdOn": "2025-06-19T14:23:16.692Z",
      "utmCampaign": "NewBooking"
    }
  ],
  "applicationInProgress": "No",
  "remortgageReason": "New_fixed_term",
  "applicants": [
    {
      "forename": "Mortgages",
      "insuranceBenefits": "none",
      "intercomUserExternalId": "57af31fe-a3a7-4b9c-852f-7cc73c6a25a6",
      "surname": "EngageScore1",
      "firstApplicant": true,
      "applicantAddressHistories": [
        {
          "postcode": "NG1 6DQ",
          "from": "2001-08-01T00:00:00.000Z",
          "nameNumber": "18",
          "city": "Nottingham",
          "street": "Friar Lane",
          "currentAddress": true
        }
      ],
      "dateOfBirth": "1980-01-31T00:00:00.000Z",
      "telephone": "07971123456",
      "employmentBenefits": "IncomeProtection",
      "id": "66d3afc3a9f9394366c3a42cfc729dac",
      "title": "Dr",
      "email": "mymojotest1@mojo.com"
    }
  ],
  "borrowingDetails": {
    "firstTimeBuyer": false,
    "desiredTimeToProceed": "AsSoonAsPossible",
    "desiredMonthlyRepayment": 2500,
    "additionalBorrowing": 0
  },
  "createdOn": "2025-06-19T14:22:53.733Z",
  "userId": 41565,
  "completePropertyDetails": {
    "typeOfProperty": "flat",
    "propertyAddress": {
      "postcode": "NG1 6DQ",
      "nameNumber": "18",
      "city": "Nottingham",
      "street": "Friar Lane"
    },
    "numberOfBedrooms": 2
  },
  "friendlyId": "KV25225185",
  "basicPropertyDetails": {
    "occupancy": "Live_in_property",
    "propertyValue": 500000
  },
  "currentMortgage": {
    "monthlyPayment": 2000,
    "yearsRemaining": 15,
    "mortgageBalance": 200000,
    "initialPeriodEndDate": "2025-07-31T00:00:00.000Z",
    "currentLender": "Santander UK Plc",
    "currentLenderCode": "CAN",
    "sixMonthsOrMoreRemaining": "no"
  },
  "term": 15,
  "tls": {
    "ptLikelyCategory": "BigQuery",
    "isPtLikely": true,
    "appointmentTypeId": 26973384,
    "color": "GREEN",
    "tier": "B",
    "isLocoCustomer": true
  },
  "remortgageDetails": {
    "remoPersona": "ApplyForRemortgage",
    "existingLenderCode": "CAN",
    "existingLender": "Santander UK Plc",
    "initialPeriodEndDate": "2025-07-31T00:00:00.000Z"
  },
  "applicationId": "be81e264598e1ac19c71e68bab0426af",
  "applicationReason": "Remortgage",
  "brand": "mojo",
  "metadata": {
    "flags": [
      "CompletedDiscovery",
      "CompletedFactFindAssumptions",
      "CompletedFactFindProperty",
      "CompletedFactFindMortgage",
      "CompletedFactFindPersonal",
      "CompletedFactFindProtection",
      "CompletedFactFindPreferences",
      "EligibilityResultApproved"
    ],
    "documents": [],
    "opportunity": {
      "status": "Closed Won",
      "applicationManager": null,
      "advisor": null,
      "lender": "Halifax"
    },
    "edeFlag": "Closed Won"
  }
}